import { Container } from "components/layout/Container";
import { Heading } from "components/layout/Heading";
import type { WriterWithReviewCardProps } from "components/shared/cards/WriterWithReviewCard";
import styles from "./SectionWriters.module.scss";
import dynamic from "next/dynamic";

const WritersSlider = dynamic(() => import("@/components/shared/sliders/WritersSlider"));

export type SectionWritersProps = {
  heading: string;
  subheading: string;
  writers: WriterWithReviewCardProps[];
};

export const SectionWriters = ({ heading, subheading, writers }: SectionWritersProps) => {
  return (
    <section className={styles.section}>
      <Container>
        <Heading title={heading} subheading={subheading} className={styles.heading} />
        <WritersSlider writers={writers} />
      </Container>
    </section>
  );
};

export default SectionWriters;
